/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Absence',dictionary:{"de":{"references":{"worker":"Mitarbeiter","type":"Art"},"remark":"Anmerkung","times":{"start":"Start","end":"Ende"}},"en":{}}})
import { Login } from './Login';
import { Worker } from './Worker';
import { AbsenceType } from './AbsenceType';
import { ProjectTimeReport } from './ProjectTimeReport';
import { WorkerTimeReport } from './WorkerTimeReport';

export class Absence extends _BaseModel {
	
	static toString() {
		return 'Absence'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Absence.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Absence', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Absence.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Absence', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Absence.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Absence', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Absence', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Absence', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Absence.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Absence', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Absence'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Absence) || _BaseModel.t('rules.reference', {modelName:'Absence', path:'meta.currentDocument'}) ],
				model: Absence,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Absence', path:'meta.revisions'}) ],
				model: Absence,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	worker:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				itemText: "references.person.__getters.titleName",
				optionName: "person",
				returnObject: true,
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Absence', path:'references.worker'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Worker) || _BaseModel.t('rules.reference', {modelName:'Absence', path:'references.worker'}) ],
				model: Worker,
},
    
	},
	
					
	type:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.AbsenceType'),
				itemText: "general.name",
				returnObject: true,
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Absence', path:'references.type'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof AbsenceType) || _BaseModel.t('rules.reference', {modelName:'Absence', path:'references.type'}) ],
				model: AbsenceType,
},
    
	},
	
					
	projectTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectTimeReport) || _BaseModel.t('rules.reference', {modelName:'Absence', path:'references.projectTimeReport'}) ],
				model: ProjectTimeReport,
				returnObject: true,
},
    
	},
	
					
	workerTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerTimeReport) || _BaseModel.t('rules.reference', {modelName:'Absence', path:'references.workerTimeReport'}) ],
				model: WorkerTimeReport,
				returnObject: true,
},
    
	},
	
},
			times: 				{
					
	start:{
		type: 'date',
		__component: 'date-time-picker',
    
		__bind: {				label: _BaseModel.t('models.Absence.times.start'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Absence', path:'times.start'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Absence', path:'times.start'}) ],
},
    __isDateTime: true,
	},
	
					
	end:{
		type: 'date',
		__component: 'date-time-picker',
    
		__bind: {				label: _BaseModel.t('models.Absence.times.end'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Absence', path:'times.end'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Absence', path:'times.end'}) ],
},
    __isDateTime: true,
	},
	
},
				
	remark:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.Absence.remark'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Absence', path:'remark'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Absence._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, times={}, remark='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.times=TimesClass.create(times);
		this.remark=remark;
		this._id=_id;
	}

	static create(data) {
		return new Absence(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Absence || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Absence.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Absence ? item : Absence.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({worker=undefined, type=undefined, projectTimeReport=undefined, workerTimeReport=undefined, }={}){
		this.worker= (worker instanceof Worker || typeof worker === 'string' || !worker) ? worker : Worker.create(worker);
		this.type= (type instanceof AbsenceType || typeof type === 'string' || !type) ? type : AbsenceType.create(type);
		this.projectTimeReport= (projectTimeReport instanceof ProjectTimeReport || typeof projectTimeReport === 'string' || !projectTimeReport) ? projectTimeReport : ProjectTimeReport.create(projectTimeReport);
		this.workerTimeReport= (workerTimeReport instanceof WorkerTimeReport || typeof workerTimeReport === 'string' || !workerTimeReport) ? workerTimeReport : WorkerTimeReport.create(workerTimeReport);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class TimesClass {
	constructor({start=undefined, end=undefined, }={}){
		this.start=start;
		this.end=end;
	}

	static create(data) {
		return new TimesClass(data);
	}
}
